import React from 'react'
import data from '../data/data.json'


const info = () => {
  const infos = data.about_me.info
  return (
    <div className='about__info grid'>
      {
        infos.map(({icon,name,experience})=>{
            return(
            <div className="about__box">
              <i className={icon}></i>
              <h3 className='about__title'>{name}</h3>
              <span className='about__subtitle'>{experience}</span>
            </div>
            )
        })
      }   
    </div>
  )
}

export default info